import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const AccrualsService = {
  async getClientAccruals(clientId, filters) {
    const params = generateQueryParams({ ...filters });

    const res = await axios.get(`org/v1/taxes/${clientId}/`, { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async recalculateAccounting(payload) {
    const res = await axios.post(`org/v1/accruals/calc/`, payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },
};
